export class DriverContact {
  id?: number;
  shipmentId?: number;
  name?: string;
  phone?: string;
  email?: string;
  trailerNumber?: string;

  constructor(opts?: Partial<DriverContact>) {
    if (opts?.id != null) {
      this.id = opts.id;
    }
    if (opts?.shipmentId != null) {
      this.shipmentId = opts.shipmentId;
    }
    if (opts?.name != null) {
      this.name = opts.name;
    }
    if (opts?.phone != null) {
      this.phone = opts.phone;
    }
    if (opts?.email != null) {
      this.email = opts.email;
    }
    if (opts?.trailerNumber != null) {
      this.trailerNumber = opts.trailerNumber;
    }
  }
}
